<template>
    <v-container class="pa-5 d-flex flex-column" fluid style="height: 100%">
        <page-title>
            Raport płyt dodatkowych
        </page-title>
        <v-row align="center">
            <v-col class="pb-0">
                <v-btn
                    text
                    color="primary"
                    class="pa-0"
                    @click="close"
                >
                    <v-icon color="primary">
                        mdi-arrow-left
                    </v-icon>
                    Powrót do listy
                </v-btn>
            </v-col>
        </v-row>
        <v-row align="center">
            <v-col cols="12" md="5" lg="3">
                <v-menu
                    v-model="menuFrom"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                >
                    <template #activator="{on}">
                        <v-text-field
                            v-model="filters.createdAt__gte"
                            label="Od"
                            prepend-icon="mdi-calendar"
                            readonly
                            solo
                            hide-details
                            append-icon
                            class="mt-0"
                            v-on="on"
                            @click:clear="clearFilter('createdAt__gte')"
                        >
                            <template slot="append-outer">
                                <div class="d-flex flex-wrap">
                                    <v-btn
                                        icon
                                        x-small
                                        class="mt-n2"
                                        data-sentry-label="Zmiana daty początku zakresu raportu"
                                        @click="getForwardDate('createdAt__gte')"
                                    >
                                        <v-icon>
                                            mdi-chevron-up
                                        </v-icon>
                                    </v-btn>
                                    <v-btn
                                        icon
                                        x-small
                                        data-sentry-label="Zmiana daty początku zakresu raportu"
                                        @click="getBackwardDate('createdAt__gte')"
                                    >
                                        <v-icon>
                                            mdi-chevron-down
                                        </v-icon>
                                    </v-btn>
                                </div>
                            </template>
                        </v-text-field>
                    </template>
                    <v-date-picker
                        v-model="filters.createdAt__gte"
                        first-day-of-week="1"
                        @input="menuFrom = false"
                    />
                </v-menu>
            </v-col>
            <v-col cols="12" md="5" lg="3">
                <v-menu
                    v-model="menuTo"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                >
                    <template #activator="{on}">
                        <v-text-field
                            v-model="filters.createdAt__lte"
                            label="Do"
                            prepend-icon="mdi-calendar"
                            readonly
                            solo
                            hide-details
                            append-icon
                            class="mt-0"
                            v-on="on"
                            @click:clear="clearFilter('createdAt__lte')"
                        >
                            <template slot="append-outer">
                                <div class="d-flex flex-wrap">
                                    <v-btn
                                        data-sentry-label="Zmiana daty końca zakresu raportu"
                                        icon
                                        x-small
                                        class="mt-n2"
                                        @click="getForwardDate('createdAt__lte')"
                                    >
                                        <v-icon>
                                            mdi-chevron-up
                                        </v-icon>
                                    </v-btn>
                                    <v-btn
                                        data-sentry-label="Zmiana daty końca zakresu raportu"
                                        icon
                                        x-small
                                        @click="getBackwardDate('createdAt__lte')"
                                    >
                                        <v-icon>
                                            mdi-chevron-down
                                        </v-icon>
                                    </v-btn>
                                </div>
                            </template>
                        </v-text-field>
                    </template>
                    <v-date-picker
                        v-model="filters.createdAt__lte"
                        first-day-of-week="1"
                        @input="menuTo = false"
                    />
                </v-menu>
            </v-col>
            <v-col cols="12" md="5" lg="3">
                <v-btn
                    data-sentry-label="Wyszukiwanie wykonanych płyt"
                    color="success"
                    @click="getAdditionalPlatesReport"
                >
                    Szukaj
                </v-btn>
            </v-col>
        </v-row>

        <v-row justify="end">
            <v-col cols="auto">
                <v-tooltip :disabled="canGenerateReport" :open-delay="tooltipDelay" top>
                    <template #activator="{on}">
                        <div v-on="on">
                            <v-btn
                                text
                                small
                                data-sentry-label="Generuj raport xlsx"
                                :disabled="!canGenerateReport"
                                @click="sendReport"
                            >
                                <v-icon
                                    small
                                    left
                                    color="success"
                                >
                                    mdi-file-excel
                                </v-icon>
                                Pobierz raport 
                            </v-btn>
                        </div>
                    </template>
                    <span>Wymagane odświeżenie danych na wykresie</span>
                </v-tooltip>
            </v-col>
            <v-col cols="auto">
                <v-tooltip :disabled="canGenerateReport" :open-delay="tooltipDelay" top>
                    <template #activator="{on}">
                        <div v-on="on">
                            <v-btn
                                text
                                small
                                data-sentry-label="Generuj raport pdf"
                                :loading="actionLoading.generateReport"
                                :disabled="!canGenerateReport"
                                @click="generateReport()"
                            >
                                <v-icon
                                    small
                                    left
                                    color="red"
                                >
                                    mdi-file-pdf
                                </v-icon>
                                Generuj wydruk
                            </v-btn>
                        </div>
                    </template>
                    <span>Wymagane odświeżenie danych na wykresie</span>
                </v-tooltip>
            </v-col>
        </v-row>
        <v-card
            width="100%"
            height="100%"
            class="d-flex flex-column"
            :loading="actionLoading.additionalPlatesReport"
        >
            <v-tabs
                v-model="tab"
                slider-color="blue"
                grow
            >
                <v-tab
                    v-for="tabData in tabs"
                    :key="tabData.id"
                    @click="prepareChartData(tabData)"
                >
                    {{ tabData.title }}
                </v-tab>
            </v-tabs>
            <v-card-text style="height: 99%; width: 100%; position: relative">
                <canvas ref="chartContainer" />
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import PageTitle from '@/components/common/PageTitle'

import filters from '@/mixins/dataTableFilters'
import dateFormatter from '@/mixins/dateFormatter'
import tooltipDelay from '@/mixins/tooltip'

import { errorHandler } from '@/utils/errorHandler'
import './../../../../public/fonts/roboto/Roboto-Light.js'

import { Chart, BarController, CategoryScale, LinearScale, BarElement } from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { format } from 'date-fns'
import { jsPDF } from 'jspdf'
import html2canvas from 'html2canvas'

export default {
    name: 'ReportAdditionalPlates',
    components: {
        PageTitle,
    },
    mixins: [ filters, dateFormatter, tooltipDelay ],
    data() {
        return {
            chart: null,
            chartData: [],
            menuFrom: false,
            menuTo: false,
            appliedFilters: {
                createdAt__gte: null,
                createdAt__lte: null,
            },
            actionLoading: {
                generateReport: false,
                additionalPlatesReport: false
            },
            tab: null,
            tabs: [
                {'id': 0, 'title': 'ZMIANY', labels: ['od 7 do 19', 'od 19 do 7'], data: []},
                {'id': 1, 'title': 'ZGŁASZAJĄCY', labels: [], data: []},
                {'id': 2, 'title': 'WYKONUJĄCY', labels: [], data: []}
            ],
            responseData: null
        }
    },
    computed: {
        currentTab() {
            return this.tab ? this.tabs[this.tab] : this.tabs[0]
        },
        userEmail() {
            return this.$store.state.user.userEmail
        },
        filterQuery() {
            const filters = Object.assign({}, this.filters)
            let query = ''

            for (let item in filters) {
                if (filters[item] !== null && typeof filters[item] !== 'undefined') {
                    if (['createdAt__gte', 'createdAt__lte'].indexOf(item) === -1) {
                        query = this.concatItemToQuery(query, item, filters[item])
                    }
                    query = this.concatItemToQuery(query, item, filters[item])
                }
            }
        
            return query
        },
        reportTitle() {
            const start = this.filters.createdAt__gte
                ? format(new Date(this.filters.createdAt__gte), 'DD.MM.YYYY')
                : 'brak'
            const end = this.filters.createdAt__lte
                ? format(new Date(this.filters.createdAt__lte), 'DD.MM.YYYY')
                : 'brak'
            const dates = `${start} - ${end}`
            
            return `Płyty dodatkowe zaraportowane w dniach ${dates}\n- widok ${this.currentTab.title}`
        },
        canGenerateReport() {
            return !!this.currentTab && !!this.currentTab.data && (
                this.appliedFilters.createdAt__gte === this.filters.createdAt__gte &&
                this.appliedFilters.createdAt__lte === this.filters.createdAt__lte
            )
        },
    },
    mounted() {
        this.setDiagram()
    },
    destroyed() {
        this.chart.destroy()
    },
    methods: {
        resetTabsData() {
            this.tabs.map(obj => {
                obj.data = []
            })
            this.tab = this.tabs[0]
        },
        concatItemToQuery(query, key, value) {
            if (query.length > 0) {
                return query.concat('&', `${key}=${value}`)
            }

            return query.concat(`${key}=${value}`)
        },
        async getAdditionalPlatesReport() {
            this.actionLoading.additionalPlatesReport = true
            this.resetTabsData()
            this.appliedFilters = Object.assign({}, this.filters)

            return await this.$store.dispatch(
                'reportsAndAnalysis/prepress/getAdditionalPlatesPrepressReports',
                {query: this.filterQuery}
            )
                .then(response => {
                    this.responseData = response.data.results
                    this.prepareChartData(this.tabs[0])
                })
                .finally(() => {
                    this.actionLoading.additionalPlatesReport = false
                })
        },
        setDiagram() {
            Chart.register(BarController, BarElement, CategoryScale, LinearScale, ChartDataLabels)

            const chartContainer = this.$refs.chartContainer

            this.chart = new Chart(chartContainer, {
                type: 'bar',
                plugins: [ChartDataLabels],
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    layout: {
                        padding: {
                            top: 20
                        }
                    },
                    scales: {
                        y: {
                            suggestedMax: 100,
                            beginAtZero: true,
                            ticks: {
                                stepSize: 10
                            }
                        }
                    },
                    plugins: {
                        datalabels: {
                            display(context) {
                                return context.dataset.data[context.dataIndex] > 0
                            },
                            anchor: 'end',
                            align: 'end',
                            offset: 4,
                            font: {
                                weight: 'bold',
                                size: 14
                            },
                        },
                        legend: {
                            display: false
                        }
                    }
                },
            })
        },
        sumByKeyValue(data, key, tabId) {
            const sumByKey = {}
            const dataStringified = JSON.stringify(data)
            const dataParsed = JSON.parse(dataStringified)

            dataParsed.forEach(obj => {
                const element = obj[key]

                if (element in sumByKey) {
                    sumByKey[element]++
                } else {
                    sumByKey[element] = 1
                }
            })

            const objects = Object.entries(sumByKey).map(([key, value]) => ({ [key]: value }))
            
            this.tabs[tabId].labels = objects.map(obj => Object.keys(obj)[0])
            this.tabs[tabId].data = objects.map(obj => Object.values(obj)[0])
        },
        sumByShifts(data) {
            const sumByRange = {
                'od 7 do 19': 0,
                'od 19 do 7': 0
            }

            data.forEach(obj => {
                const createdAt = new Date(obj.plateOrderCreatedAt)
                const hour = createdAt.getHours()
                
                if (hour >= 7 && hour < 19) {
                    sumByRange['od 7 do 19']++
                } else {
                    sumByRange['od 19 do 7']++
                }
            })

            const objects = Object.entries(sumByRange).map(([title, sum]) => ({ title, sum }))
            
            this.tabs[0].labels = objects.map(obj => obj.title)
            this.tabs[0].data = objects.map(obj => obj.sum)
        },     
        prepareChartData(tabData) {
            if (!this.responseData) return
            if (tabData.id === 0) {
                if (tabData.labels.length === 0 || tabData.data.length === 0) {
                    this.sumByShifts(this.responseData)
                }
            } else if (tabData.id === 1) {
                if (tabData.labels.length === 0 || tabData.data.length === 0) {
                    this.sumByKeyValue(this.responseData, 'plateOrderCreator', tabData.id)
                }
                
            } else if (tabData.id === 2) {
                if (tabData.labels.length === 0 || tabData.data.length === 0) {
                    this.sumByKeyValue(this.responseData, 'checkedBy', tabData.id)
                }
                
            }
            this.setSelectedChartData(this.tabs[tabData.id].labels, this.tabs[tabData.id].data)
        },
        setSelectedChartData(labels, values) {
            this.chart.data.labels = labels
            this.chart.data.datasets = [{
                data: values,
                backgroundColor: '#2196F3',
                borderWidth: 0,
                borderRadius: 5,
            }]

            this.chart.update()
        },
        getBackwardDate(date) {
            if (Date.parse(this.filters[date])) {
                this.filters[date] = this.getDayBackward(this.filters[date])
            }
        },
        getForwardDate(date) {
            if (Date.parse(this.filters[date])) {
                this.filters[date] = this.getDayForward(this.filters[date])
            }
        },
        generateReport() {
            this.actionLoading.generateReport = true

            html2canvas(this.$refs.chartContainer)
                .then(canvas => {
                    const imgData = canvas.toDataURL('image/png'),
                        doc = new jsPDF({
                            orientation: 'landscape'
                        })

                    doc.setFont('Roboto-Light')
                    doc.text(`${this.reportTitle}`, 10, 10)
                    doc.addImage(imgData, 'PNG', 10, 40, 275, 130)
                    doc.setFontSize(10)

                    doc.text(`Wygenerowano: ${this.formatDate(new Date())}`, 10, 200)

                    window.open(doc.output('bloburl'), '_blank')
                    this.actionLoading.generateReport = false

                })
                .catch(() => {
                    this.actionLoading.generateReport = false
                })
        },
        close() {
            this.$router.push({ name: 'ReportingAndAnalysisPrepressPrepress' })
                .catch(error => {
                    errorHandler(error)
                })
        },
        sendReport() {
            this.$store.dispatch('toggleMainLoader', true)
            let query = this.filterQuery
            const connector = query ? '&' : ''

            query = query + `${connector}report=true`
            
            this.$store.dispatch('reportsAndAnalysis/prepress/getAdditionalPlatesPrepressReports', {query: query, userEmail: this.userEmail})
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.$store.dispatch('toggleMainLoader', false)
                })
        },
    }
}
</script>